import type { AskTicketPriority } from '@core/ask-hr-types';
import type { IconToken } from '@core/user-interface-legacy';

export const priorityColorMap: Record<AskTicketPriority, IconToken> = {
  low: 'colorIconDisabled',
  normal: 'colorIconInfoDefault',
  high: 'colorIconWarningDefault',
  urgent: 'colorIconCriticalStrongDefault',
};
